export enum LanguageList {
    SPANISH = "es",
    ENGLISH = "en"
}

export const DefaultLanguage = LanguageList.ENGLISH;
